import { render } from "./record-table.vue?vue&type=template&id=28aca62e"
import script from "./record-table.vue?vue&type=script&lang=js"
export * from "./record-table.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__